<template>
    <div class="tag">
      <div class="tag-name">
        {{tag.label}}
      </div>
      <div class="tag-action" v-if="tagAction" @click="onClick(tagAction)">
        <i class="icon-tag-add"></i>
        {{tagAction.name}}
      </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import circleEnum from '@/common/enums/defaultCircle';

export default {
  name: "tags",
  data() {
    return {
      // for mc-web#253
      menu: {
      //   '内容列表': {
      //     name: '新增内容',
      //     permission: 'content_list_add',
      //     url: `/content/list/add?circleId=${circleEnum.HOME.circleId}`,
      //   },
      //   '网页素材': {
      //     name: '新增内容',
      //     permission: 'content_material_add',
      //     url: `/content/list/add?circleId=${circleEnum.HTML_MATERIAL.circleId}`,
      //   },
      //   '话题管理': {
      //     name: '新增话题',
      //     permission: 'topic_add',
      //     url: `/content/topic/add`,
      //   },
      //   '分类管理': {
      //     name: '新增分类',
      //     permission: 'classification_add',
      //     url: `/content/classification/add`,
      //   }
      }
    };
  },
  computed: {
    ...mapGetters(["tag", "permissions"]),
    tagAction () {
      const action = this.menu[this.tag.label];
      if (action && this.permissions[action.permission]) {
        return this.menu[this.tag.label];
      }
      return null;
    }
  },
  methods: {
    onClick(tagAction) {
      this.$router.push({path: tagAction.url})
    }
  },
};
</script>

<style lang="scss">
.tag {
  display: flex;
  align-items: center;
  margin: 22px 20px;
  font-size: 16px;
  color: #3B3B3B;
  font-weight: 800;
  .tag-name {
    font-size: 16px;
    color: #3B3B3B;
    font-weight: 800;
  }
  .tag-action {
    display: flex;
    align-items: center;
    margin-left: 30px;
    font-size: 14px;
    color: #5383f3;
    cursor: pointer;
  }
  .icon-tag-add {
    margin-right: 3px;
  }
}
</style>


